import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useLeoStore } from "../../stores/leo";

/** `/leo` (lien du site vitrine, favoris) : ouvre la bulle de Léo sur le tableau de bord. */
export function LeoRoute() {
  const setOpen = useLeoStore((s) => s.setOpen);
  useEffect(() => {
    setOpen(true);
  }, [setOpen]);
  return <Navigate to="/dashboard" replace />;
}
